var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H21C25.4183 0 29 3.58172 29 8V21C29 25.4183 25.4183 29 21 29H8C3.58172 29 0 25.4183 0 21V8Z",
    fill: "#E2FFFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7052 4H7.22311C6.00398 4 5 4.9719 5 6.15207V22.8132C5 23.9934 6.00398 25 7.25896 25H20.741C21.9602 25 23 24.0281 23 22.8132V6.15207C22.9283 4.9719 21.9243 4 20.7052 4ZM21.3147 22.8132C21.3147 23.1603 21.0279 23.438 20.6693 23.438H7.22311C6.86454 23.438 6.57769 23.1603 6.57769 22.8132V6.15207C6.57769 5.80496 6.86454 5.52727 7.22311 5.52727H20.7052C21.0637 5.52727 21.3506 5.80496 21.3506 6.15207V22.8132H21.3147Z",
    fill: "#003DA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6572 6.44214H14.7918C14.1535 6.44214 13.6216 6.97407 13.6216 7.61238V12.2934C13.6216 12.9317 14.1535 13.4636 14.7918 13.4636H18.6572C19.2955 13.4636 19.8274 12.9317 19.8274 12.2934V7.57692C19.792 6.97407 19.2955 6.44214 18.6572 6.44214ZM18.1962 11.8324H15.2174V8.03793H18.1962V11.8324Z",
    fill: "#003DA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41627 8.52267H11.005C11.4305 8.52267 11.8206 8.16805 11.8206 7.70704C11.8206 7.24604 11.466 6.92688 11.005 6.92688H8.38081C7.95527 6.92688 7.56519 7.2815 7.56519 7.7425C7.56519 8.20351 7.95527 8.52267 8.41627 8.52267Z",
    fill: "#003DA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7986 13.1443H11.3873C11.8129 13.1443 12.2029 12.7897 12.2029 12.3287C12.2029 11.8677 11.8483 11.5131 11.3873 11.5131H8.76313C8.33759 11.5131 7.94751 11.8677 7.94751 12.3287C7.94751 12.7897 8.33759 13.1443 8.7986 13.1443Z",
    fill: "#003DA5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0113 16.0524H8.79829C8.37275 16.0524 7.98267 16.407 7.98267 16.868C7.98267 17.329 8.33729 17.6836 8.79829 17.6836H19.0113C19.4369 17.6836 19.827 17.329 19.827 16.868C19.827 16.407 19.4369 16.0524 19.0113 16.0524Z",
    fill: "#003DA5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0113 20.556H8.79829C8.37275 20.556 7.98267 20.9107 7.98267 21.3717C7.98267 21.8327 8.33729 22.1873 8.79829 22.1873H19.0113C19.4369 22.1873 19.827 21.8327 19.827 21.3717C19.827 20.9107 19.4369 20.556 19.0113 20.556Z",
    fill: "#003DA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentBlue);
export default __webpack_public_path__ + "static/media/document-blue.f0c6876604dcfe3d0b2b2104d510fb7b.svg";
export { ForwardRef as ReactComponent };